import { useReveal } from "@/lib/useReveal";

const STATES = [
  "Texas", "Arizona", "California", "Florida", "Georgia", "Nevada",
  "New Mexico", "Oklahoma", "Louisiana", "Tennessee", "Alabama",
  "Mississippi", "North Carolina", "South Carolina", "Missouri", "Kansas",
];

export const StatesServed = () => {
  const ref = useReveal();
  return (
    <section
      data-testid="states-section"
      ref={ref}
      className="bg-[#0A192F] py-16 border-y border-[#D4AF37]/20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-16">
          <div className="lg:w-1/3 reveal">
            <div className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] mb-3">
              Where We Operate
            </div>
            <h3 className="font-serif-display text-[#FDFBF7] text-3xl md:text-4xl leading-tight">
              Texas-rooted.
              <br />
              <em className="italic text-[#D4AF37]">Nationally active.</em>
            </h3>
          </div>
          <div className="lg:w-2/3 reveal" style={{ transitionDelay: "120ms" }}>
            <div className="flex flex-wrap gap-x-6 gap-y-3">
              {STATES.map((s) => (
                <span
                  key={s}
                  className="text-[#E2DCD0] text-sm tracking-wide border-b border-transparent hover:border-[#D4AF37] transition-colors"
                >
                  {s}
                </span>
              ))}
              <span className="text-[#D4AF37] text-sm italic">+ more on request</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
